<template>
  <div>
    <div class="box has-text-centered">
      <div class="title">Deze pagina is onder constructie</div>
      Bedankt voor uw bestelling! <br />
      Helaas is het op dit moment nog niet mogelijk om uw bestelling online aan
      te passen.
      <br />
      <br />
      Mocht u toch een wijziging willen doorgeven dan kun je ons bellen van
      maandag t/m woensdag tussen 11:00 en 13:00 op <br />telefoonnummer: 0575
      796074 of per <br />
      e-mail: soep@hetdagelijksbestaan.nl
      <br />
      <br />
      <div class="button is-rounded is-primary" @click="returnToHomePagina()">
        Naar Homepagina
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: [],
  data() {
    return {
      interval: "",
      timeTillReturn: 10,
    };
  },
  computed: {
    calculateSeconden() {
      if (this.timeTillReturn === 1) {
        return "seconde";
      } else {
        return "seconden";
      }
    },
  },
  methods: {
    returnToHomePagina() {
      clearInterval(this.interval);
      this.$router.replace({ name: "home" });
    },
    returnToHome() {
      clearInterval(this.interval);
      if (this.$router.currentRoute.name === "contact-formulier-verzonden") {
        this.$router.replace({ name: "home" });
      }
    },
  },
  mounted() {},
};
</script>
